import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div className={className} initial={{ opacity: 0.25, y }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}>
    {children}
  </motion.div>
);

const frame = { hide: { clipPath: "inset(10% 8% 10% 8% round 6px)" }, show: { clipPath: "inset(0% 0% 0% 0% round 6px)" } };
const zoom = { hide: { scale: 1.18 }, show: { scale: 1 } };
const ease = { duration: 1.3, ease: [0.16, 1, 0.3, 1] };

export const ClipImage = ({ src, alt, className = "", testId }) => (
  <motion.div className={`h-full w-full ${className}`} initial="hide" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
    <motion.div variants={frame} transition={ease} className="h-full w-full overflow-hidden">
      <motion.img variants={zoom} transition={ease} src={src} alt={alt} data-testid={testId} className="h-full w-full object-cover" />
    </motion.div>
  </motion.div>
);
